import React from "react";
import PropTypes from "prop-types";
// import InfoModal from './InfoModal'
import OptionLink from "./OptionLink";

class PrintingOptionFilter extends React.Component {
  renderOptions() {
    // Build the list of Printing Style options
    return this.props.printOptions.map((printOption) => {
      return (
        <OptionLink
          key={printOption.value}
          filterName={this.props.name}
          printOption={printOption}
          onChooseOption={this.props.onChooseOption}
          isSelected={this.props.selectedValue === printOption.value}
        />
      );
    });
  }

  render() {
    return (
      <div
        className={`tool tool--printoptionfilter tool--printoptionfilter--${this.props.id}`}
      >
        <h4 className="tool__header">
          {this.props.name}
          {/*<InfoModal/> /!* TODO: We'll need to change this to be print option filter specific*!/*/}
        </h4>

        <div className="tool__options tool--printoptionfilter-links">
          {this.renderOptions()}
        </div>
      </div>
    );
  }
}

PrintingOptionFilter.propTypes = {
  printOptions: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  showThumbnails: PropTypes.bool.isRequired,
  onChooseOption: PropTypes.func.isRequired,
  selectedValue: PropTypes.string,
};

export default PrintingOptionFilter;
